module.exports = __webpack_public_path__ + "static/media/poup-screenshot.01d31c82.jpg";